var render, staticRenderFns
import script from "./CoreTable.vue?vue&type=script&lang=js"
export * from "./CoreTable.vue?vue&type=script&lang=js"
import style0 from "./CoreTable.vue?vue&type=style&index=0&id=3e8f50aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8f50aa",
  null
  
)

export default component.exports